
/**
 * Calculates the Haversine distance between two points on Earth.
 * @param lat1 Latitude of point 1
 * @param lon1 Longitude of point 1
 * @param lat2 Latitude of point 2
 * @param lon2 Longitude of point 2
 * @returns Distance in kilometers
 */
const ROAD_DISTANCE_MULTIPLIER = 1.32; // Road distance is approx 32% longer than straight line in urban areas

export const calculateDistance = (lat1: number, lon1: number, lat2: number, lon2: number): number => {
    const R = 6371; // Earth's radius in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const straightDistance = R * c;
    return straightDistance * ROAD_DISTANCE_MULTIPLIER;
};

/**
 * Calculates delivery fee based on distance.
 * @param distance Distance in kilometers
 * @param rate Rate per kilometer (default 100 DA)
 * @param minFee Minimum delivery fee (default 100 DA)
 * @returns Calculated fee rounded to nearest 5 DA
 */
export const calculateDeliveryFee = (distance: number, rate: number = 100, minFee: number = 100): number => {
    // Round distance to 2 decimal places to avoid precision issues
    const roundedDistance = Math.round(distance * 100) / 100;
    const fee = Math.max(minFee, roundedDistance * rate);
    return Math.round(fee / 5) * 5; // Round to nearest 5 DA for convenience
};
